import { useEffect } from 'react'

import { useAppDispatch, useAppSelector } from '@/store/hook'
import {
  selectUserCountryId,
  selectUserCurrency,
  selectUserLanguage,
  selectUserStatusLowerCase,
} from '@/store/selectors/userSelector'
import { trackApplication } from '@/store/slices/adobeAnalyticSlice'
import { selectUserType } from '@/store/slices/authenticationSlice'
import { getMiniCart } from '@/store/slices/cartSlice'
import { USER_STATUS, USER_TYPES } from '@/libs/constants/user'
import { getLanguageCode } from '@/libs/utils/adobeAnalysis'

const ActionsDispatcher = (): null => {
  const dispatch = useAppDispatch()

  const userStatus = useAppSelector(selectUserStatusLowerCase)
  const countryId = useAppSelector(selectUserCountryId)
  const language = useAppSelector(selectUserLanguage)
  const currency = useAppSelector(selectUserCurrency)
  const userType = useAppSelector(selectUserType)

  useEffect(() => {
    if (
      userStatus === USER_STATUS.AUTHORIZED
      && userType !== USER_TYPES.EMPLOYEE_USER
      && userType !== USER_TYPES.TECHNICAL_USER
    ) {
      dispatch(getMiniCart())
    }
  }, [dispatch, userStatus, userType])

  useEffect(() => {
    if (countryId && currency && language) {
      dispatch(
        trackApplication({
          country: countryId,
          currency,
          language: getLanguageCode(language),
        }),
      )
    }
  }, [dispatch, countryId, currency, language])

  return null
}

export default ActionsDispatcher
